'use strict';

angular.module('far.models.competition.competitionReport', [])
    .service('CompetitionReport', function ($log, $http, usersHelper) {
        this.new = function (data, userTypes) {
            return new Competition(data, userTypes);
        };

        this.delete = function (route, callback) {
            return $http.delete(Routing.generate('api_delete_competition', {competition: route.id}))
                .then(function () {
                    route = null;

                    if (typeof callback == 'function') {
                        callback();
                    }
                }, function errorCallback(response) {
                    $log.error(response);
                });
        };

        this.restore = function (route) {
            return $http.patch(Routing.generate('api_patch_competition', {id: route.id}))
                .then(function () {
                    return route = null;
                }, function errorCallback(response) {
                    $log.error(response);
                });
        };

        this.get = function (routeId, userTypes, callback) {
            var route = new Competition({eventReportEdit: 1, eventId: routeId}, userTypes);

            $http.get(Routing.generate('api_event_get_event_report', {id: routeId}))
                .then(function (response) {
                    route.update(response.data);

                    if (typeof callback == 'function') {
                        callback(route);
                    }
                }, function errorCallback(response) {
                    $log.error(response);
                });

            return route;
        };

        function Competition(data, userTypes) {
            this.users = [];

            angular.merge(this, data);

            Object.defineProperty(this, 'update', {
                enumerable: false,
                get: function () {
                    return function (data) {
                        if (data.documents_files) {
                            delete this.documents_files;
                        }

                        angular.merge(this, data);

                        this.updateUsers();

                        return this;
                    }
                }
            });

            Object.defineProperty(this, 'save', {
                enumerable: false,
                get: function () {
                    return function () {
                        var method = this.eventReportEdit ? 'put' : 'post',
                            url = this.eventReportEdit ?
                                Routing.generate('api_event_put_event_report', {id: this.eventId}) :
                                Routing.generate('api_event_post_event_report');

                        // Могу преобразовывать data как хочу.
                        var data = angular.extend({}, this);

                        if (data.documents_files && data.documents_files.length > 0) {
                            data.documents_files = data.documents_files.filter(function (documentFile) {
                                return angular.isDefined(documentFile.serverData);
                            }).map(function (documentFile) {
                                return documentFile.serverData.id;
                            });
                        }

                        return $http[method](url, data);
                    }
                }
            });

            usersHelper.initUsers(this, userTypes, 'users', 'event_competition_user_type');

            this.createUser(this.userTypes.safety);
            this.createUser(this.userTypes.judge);
        }
    });